import { InvoiceStates, UserRols } from "../../../constants";

export const AllowUserMoreOptionsPurchases = [
	UserRols.DEFAULT_USER,
	UserRols.ORG_ADMIN,
	UserRols.ARO_ADMIN,
	UserRols.ACCOUNTANT,
];

export const AllowedInvoicesStatesForEditPurchases = [
	InvoiceStates.UNVERIFIED,
];

export const AllowedInvoicesStatesForMassiveVerificationPurchases = [
	InvoiceStates.HISTORY,
	InvoiceStates.EXCLUDED,
	InvoiceStates.NOTIFICATION_SENT,
	InvoiceStates.ERROR,
];